/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Source_MuxInputs */



/**
* | output |
* | --- |
* | "Mux" |
*
* @param {New_Project_Media_Source_MuxInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_source_mux = /** @type {((inputs?: New_Project_Media_Source_MuxInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Source_MuxInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mux")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mux")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mux")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Mux")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mux")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Mux")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Mux")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Mux")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mux")
	return /** @type {LocalizedString} */ ("Mux")
});